type SaveShortcutEvent = {
  altKey?: boolean;
  code?: string;
  ctrlKey?: boolean;
  key?: string;
  metaKey?: boolean;
  shiftKey?: boolean;
};

function isSaveShortcut(event: SaveShortcutEvent) {
  const key = typeof event.key === 'string'
    ? event.key.toLowerCase()
    : '';
  const code = typeof event.code === 'string'
    ? event.code
    : '';
  const hasSaveModifier = Boolean(event.ctrlKey || event.metaKey);
  const isSaveKey =
    key === 's'
    || code === 'KeyS'
    || key === 'enter';

  return (
    hasSaveModifier
    && isSaveKey
    && !event.altKey
    && !event.shiftKey
  );
}

export default isSaveShortcut;
